function soundToggler(audioMain) {
  
 
  const cenaCheckbox = document.getElementById('sound');

  const myfunction = () => {
    if (cenaCheckbox.checked) {
      audioMain.pause();
    } else {
      audioMain.play();
    }
  };
  
  cenaCheckbox.addEventListener('click', () => {
    myfunction();
  });
}

export default soundToggler;